<template>
  <div class="container-fluid">
    <div class="row bg-light text-left border-top border-bottom py-2">
      <div class="col-sm-12 px-0 h-100 my-auto">
        <span class="mx-3 font-weight-bold lead">Company Profile</span>
        <span class="mx-3" v-if="!guest">
          <button class="btn btn-sm btn-outline-primary font-weight-bolder"
                  title="Add New Company Certificate"
                  data-toggle="modal" data-target="#addNewCertificate" :disabled="this.manningId ==0">
              <span class="fas fa-user-plus"></span>
              Add Manning Files
        </button>
        </span>

        <span class="mx-3" v-if="isPrincipal">
          <select class="custom-select-sm" v-model="manning_id"  @change="getManningFileList">
<!--            <option :value="0">&#45;&#45; Please Select Manning &#45;&#45;</option>-->
                <option v-for="manning in manningKeys" :key="manning.id"
                        :value="manning.id"
                        :selected="manning_id == manning.id">
                  {{manning.alias}}
                </option>
          </select>
        </span>

      </div>
    </div>

    <div class="row text-small py-3">
      <div class="col-sm-12">
        <table class="table table-hover table-sm border-bottom table-bordered">
          <thead class="bg-lightgray">
          <tr>
            <th class="border-0" scope="col">#</th>
            <th class="border-0" scope="col">Document No.</th>
            <th class="border-0" scope="col">Document Name</th>
            <th class="border-0" scope="col" v-if="isPrincipal">Manning</th>
            <th class="border-0" scope="col">Date Issued</th>
            <th class="border-0" scope="col">Date Expiry</th>
<!--            <th class="border-0" scope="col">Created By</th>-->
<!--            <th class="border-0" scope="col">Created At</th>-->
            <th class="border-0" scope="col">Updated By</th>
            <th class="border-0" scope="col">Updated At</th>
            <th class="border-0" scope="col">Action</th>
          </tr>
          </thead>
          <tbody>
            <tr v-for="(manningFile,index) in manningFiles" :key="manningFile.id">
            <th scope="row">{{index+1}}</th>
            <th scope="row">{{manningFile.doc_no}}</th>
            <td>{{manningFile.doc_name}}</td>
            <td v-if="isPrincipal">{{manningFile.manning_alias.toUpperCase() || '' }}</td>
            <td>{{manningFile.issued_date | moment('DD MMM YYYY') }}</td>
            <td>{{manningFile.expiry_date | moment('DD MMM YYYY') }}</td>
<!--            <td>{{manningFile.created_by || '' }}</td>-->
<!--            <td>{{manningFile.created_at | moment('DD MMM YYYY') }}</td>-->
            <td>{{manningFile.updated_by ? manningFile.updated_by : manningFile.created_by }}</td>
            <td>{{manningFile.updated_at | moment('DD MMM YYYY') }}</td>
            <td>
              <button v-if="manningFile.hasFile" @click="view(manningFile.id)" class="btn btn-sm btn-xs btn-outline-info font-weight-bolder py-1 mr-1 ml-auto">
                <span class="fas fa-eye"></span>
                View
              </button>

              <button class="btn btn-sm btn-xs btn-outline-success font-weight-bolder py-1 mr-1 ml-auto"
                      data-toggle="modal"
                      data-target="#updateDoc"
                      @click="getFile(manningFile)"
                      v-if="((manningFile.isPrincipal && isPrincipal) || (!manningFile.isPrincipal && isManning)) && !guest"
              >
                <i class="fas fa-edit"></i>
                Update
              </button>

              <button v-if="isPrincipal" class="btn btn-sm btn-xs btn-outline-danger font-weight-bolder py-1 mr-1 ml-auto" @click.prevent="deleteFile(manningFile.id)">
                <i class="fas fa-edit"></i>
                Delete
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <!-- Update Document Modal -->
      <div class="modal fade" id="updateDoc" tabindex="-1" role="dialog"  aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content modal-lg">
            <div class="modal-header">
              <h5 class="modal-title">Manning File</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <!-- form -->
            <form @submit.prevent="update">
              <div class="modal-body">
                <div class="form-group row">
                  <label for="doc_no_update" class="col-sm-2 col-form-label col-form-label-sm">Document No</label>
                  <div class="col-sm-10 text-left">
                    <input type="text" class="form-control form-control-sm" id="doc_no_update" v-model="manningFile.doc_no" :readonly="!isFormEditable">
                  </div>
                </div>

                <div class="form-group row">
                  <label for="issued_date_update" class="col-sm-2 col-form-label col-form-label-sm">Date Issued</label>
                  <div class="col-sm-10 text-left">
                    <input type="date" class="form-control form-control-sm" id="issued_date_update" v-model="manningFile.issued_date" :readonly="!isFormEditable">
                  </div>
                </div>

                <div class="form-group row">
                  <label for="expiry_date_update" class="col-sm-2 col-form-label col-form-label-sm">Date Expiry</label>
                  <div class="col-sm-10 text-left">
                    <input type="date" class="form-control form-control-sm" id="expiry_date_update" v-model="manningFile.expiry_date" :readonly="!isFormEditable">
                  </div>
                </div>

                <div class="form-group row">
                  <label for="file_update" class="col-sm-2 col-form-label col-form-label-sm">Select File</label>
                  <div class="col-sm-10 text-left">
                    <select class="form-control form-control-sm" id="file_update" v-model="manningFile.file_id" disabled>
                      <option :value="null">--Please Select Document--</option>
                      <option v-for="file in files" :key="file.id"
                              :value="file.id" :selected="manningFile.file_id == file.id">
                        {{ file.name }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="form-group row">
                  <label for="manning_file_update" class="col-sm-2 col-form-label col-form-label-sm">Upload File</label>
                  <div class="col-sm-10 text-left">
                    <div class="form-group">
                      <input type="file"
                             class="form-control-file"
                             id="manning_file_update"
                             accept="application/pdf"
                             :disabled="!isFormEditable"
                      >
                    </div>
                  </div>
                </div>

              </div>

              <div class="modal-footer">
                <button v-if="isFormEditable" type="button" class="btn btn-secondary btn-sm" @click.prevent="cancelUpdate">
                  <i class="fas fa-times"></i>
                  Cancel
                </button>

                <button type="submit" class="btn btn-primary btn-sm">
                  <i class="fas fa-save"></i>
                  {{ isFormEditable ? 'SAVE CHANGES': 'UPDATE' }}
                </button>
              </div>
            </form>

          </div>
        </div>
      </div>

    </div>

    <!-- Add New Document Modal -->
    <div class="modal text-small fade" id="addNewCertificate" tabindex="-1" role="dialog"  aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content modal-lg">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">Add Company Certificate</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form @submit.prevent="save">
            <div class="modal-body">

              <div class="form-group row">
                <label for="doc_no" class="col-sm-2 col-form-label col-form-label-sm">Document No</label>
                <div class="col-sm-10 text-left">
                    <input type="text" class="form-control form-control-sm" id="doc_no" v-model="manningFile.doc_no" >
                </div>
              </div>

              <div class="form-group row">
                <label for="issued_date" class="col-sm-2 col-form-label col-form-label-sm">Date Issued: </label>
                <div class="col-sm-10 text-left">
                  <input type="date" class="form-control form-control-sm" id="issued_date" v-model="manningFile.issued_date">
                </div>
              </div>

              <div class="form-group row">
                <label for="expiry_date" class="col-sm-2 col-form-label col-form-label-sm">Date Expiry: </label>
                <div class="col-sm-10 text-left">
                  <input type="date" class="form-control form-control-sm" id="expiry_date" v-model="manningFile.expiry_date">
                </div>
              </div>

              <div class="form-group row">
                <label for="file" class="col-sm-2 col-form-label col-form-label-sm">Select File: </label>
                <div class="col-sm-10 text-left">
                  <select class="form-control form-control-sm underline" id="file" required v-model="manningFile.file_id">
                    <option :value="''">--Please Select Document--</option>
                    <option v-for="file in files" :key="file.id"
                            :value="file.id"
                            :disabled="valMatch(file.id)">
                      {{file.name}} <span v-if="valMatch(file.id)" >- (document exist)</span>
                    </option>
                  </select>
                </div>
              </div>

              <div class="form-group row">
                <label for="manning_file" class="col-sm-2 col-form-label col-form-label-sm">Upload File: </label>
                <div class="col-sm-10 text-left">
                  <div class="form-group">
                    <input type="file" class="form-control-file" id="manning_file" accept="application/pdf">
                  </div>
                </div>
              </div>
          </div>
            <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" @click="cancelAdd">
              <i class="fas fa-times"></i>
              Cancel
            </button>
            <button type="submit" class="btn btn-primary btn-sm">
              <i class="fas fa-save"></i>
              Save
            </button>
          </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters,mapActions} from 'vuex';
import {USER_DETAILS} from '../../../../services/ConstantService';
import {gateMixin} from '../../../../mixins/gateMixin';
import {vueAppMixin} from '../../../../mixins/vueAppMixin';

export default {
  name: "CompanyIndex",
  mixins: [vueAppMixin,gateMixin],
  data(){
    return {
      manning_id: 1,
      editableFields: ['doc_no', 'issued_date', 'expiry_date'],
    }
  },

  methods:{
    ...mapActions(['getFiles','getManningFiles','saveManningFile','pullUserDetails','clearManningFile','viewManningFile','getManningFile','setFormEditable','updateManningFile','deleteManningFile','getAllManningKeys']),

    getManningFileList(){
      return this.getManningFiles({manning_id : this.manningId});
    },

    getFile(manning){
        if(manning) {
            this.getManningFile(manning.id);
        }
    },

    resetFileInput(){
      document.getElementById('manning_file_update').value = '';
      document.getElementById('manning_file').value = '';
    },

   async save(){

     if(await this.confirmCreateAlert()) {
       let file = document.getElementById('manning_file').files[0];
       this.manningFile.manning_id = this.manningId;
       let formData = new FormData();
       // formData.append('doc_no',this.manningFile.doc_no);
       // formData.append('issued_date',this.manningFile.issued_date);
       // formData.append('expiry_date',this.manningFile.expiry_date);
       this.editableFields.forEach(key => {
         let value = this.manningFile[key] ? this.manningFile[key] : '';
         if(value === '0000-00-00') value = '';
         formData.append(key, value);
       });
       formData.append('file_id',this.manningFile.file_id);
       formData.append('manning_id',this.manningFile.manning_id);
       formData.append('manning_file',file);
       await this.saveManningFile(formData).then((response)=>{
         if(response){
           this.resetFileInput();
           this.successAlert('Manning File Save Successfully','SAVE MANNING FILE');
           this.getManningFiles({manning_id : this.manningId});
           this.clearManningFile();
           $('#addNewCertificate').modal('hide');
         }
       });
     }

    },

    async update(){
      if(this.isFormEditable){
        if(await this.confirmUpdate()){
          let file = document.getElementById('manning_file_update').files[0];
          this.manningFile.manning_id = this.manningId;
          let formData = new FormData();
          formData.append('id',this.manningFile.id);
          // formData.append('doc_no',this.manningFile.doc_no);
          // formData.append('issued_date',this.manningFile.issued_date);
          // formData.append('expiry_date',this.manningFile.expiry_date);
          this.editableFields.forEach(key => {
            let value = this.manningFile[key] ? this.manningFile[key] : '';
            if(value === '0000-00-00') value = '';
            formData.append(key, value);
          });
          formData.append('file_id',this.manningFile.file_id);
          formData.append('manning_id',this.manningFile.manning_id);
          if(file){
            formData.append('manning_file',file);
          }

          this.updateManningFile(formData).then((response)=>{
            if(response){
              this.resetFileInput();
              this.successAlert('Update Successfully','Update ManningFile');
              this.getManningFiles({manning_id : this.manningId});
            };
          }).catch((e)=>{

          });
        }
      }
      this.setFormEditable();
    },

    async deleteFile(id){
      if(await this.confirmDeleteAlert()) {
        this.deleteManningFile(id).then((response)=>{
          if(response){
            this.successAlert('Delete Successfully','Delete ManningFile');
            this.getManningFiles({manning_id : this.manningId});
          }
        }).catch((e)=>{

        });
      }
    },

   async view(id){
     this.viewManningFile(id);
     // await this.viewManningFile(id).then((response)=>{
     //
     //    if(response){
     //      const win = window.open('', '_blank');
     //      const pdf = this.pdfFile;
     //      const html = `
     //        <html>
     //          <title>Manning Document</title>
     //          <body style="margin:0!important;">
     //            <object width="100%" height="100%" data="data:application/pdf;base64,${pdf}" type="application/pdf"></object>
     //          </body>
     //        </html>`;
     //      win.document.write(html);
     //    }
     //  }).catch((e)=>{
     //
     // });
    },

    cancelAdd(){
      this.clearManningFile();
    },

    cancelUpdate(){
      this.setFormEditable();
    },

    valMatch (file_id){
      return this.manningFiles.filter(function(manningFile) {
        return manningFile.file_id === file_id;

      }).length > 0 ;
    },

      async initializeData() {
        if(this.isManning && !this.isSystemAdmin) {
            this.manning_id = this.user.manning_id;
        }
        await this.pullUserDetails();
        await this.getFiles();
        await this.getManningFiles({manning_id : this.manning_id});
        await this.getAllManningKeys();
      }

  },

  computed:{
    ...mapGetters(['files','manningFile','manningFiles','user','pdfFile','isFormEditable','manningKeys']),

    manningId(){
      if(this.user.manning_id){
          return  this.user.manning_id;
      }
      return this.manning_id;
    }
  },

  mounted() {

  },

  created() {
    this.initializeData();
  },
}
</script>

<style scoped>
  .bg-lightgray {
    background: lightgray;
  }


  select option:disabled {
    background: white;
  }

</style>
